const MainCollection = {
    store, 
    name: 'MainCollection',
    delimiters: ['${', '}'],
    data() {


        return {
          prueba: 'prueba'
        }

    },
    created() {

    },
    methods:{

      addToCart(id, qty){
        
        store.dispatch('addToCart', {id, qty})
        .then((response) => {


        })
      }

    }

}

const MainCollectionApp = Vue.createApp(MainCollection)

mountVueComponent(MainCollectionApp,'custom-price')
MainCollectionApp.mount('.MainCollection')
MainCollectionApp.use(store)
